import script from "./BlogFooterTop.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlogFooterTop.vue?vue&type=script&lang=ts&setup=true"

import "./BlogFooterTop.vue?vue&type=style&index=0&id=6965cbac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6965cbac"]])

export default __exports__